import { Skeleton } from '@mui/material'
import React from 'react'

const UserRowLoadding = () => {
  return (
    <div className='row ' style={{margin : "5px 0px"}}>
        <div className='circle cell'> <Skeleton width={50} height={50} variant="circular" /> </div>
        <div className='line cell' > <Skeleton width={120} /> </div>
        <div className='line cell' > <Skeleton width={120} /> </div>
        <div className='line cell' > <Skeleton width={120} /> </div>
        <div className='line cell' > <Skeleton width={120} /> </div>
        <div className='line cell' > <Skeleton width={120} /> </div>
    </div>
  )
}

export default UserRowLoadding
